var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path, _rect15, _rect16, _rect17, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLegalDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03699,
    y: 3.62988,
    width: 13.4815,
    height: 0.77778,
    rx: 0.38889,
    fill: "#E62645"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03711,
    y: 5.44434,
    width: 13.4815,
    height: 0.77778,
    rx: 0.38889,
    fill: "#E62645"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03711,
    y: 7.25977,
    width: 13.4815,
    height: 0.77778,
    rx: 0.38889,
    fill: "#E62645"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03711,
    y: 10.6299,
    width: 13.4815,
    height: 0.77778,
    rx: 0.38889,
    fill: "#E62645"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03711,
    y: 12.4443,
    width: 13.4815,
    height: 0.77778,
    rx: 0.38889,
    fill: "#E62645"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 21.2593,
    rx: 2,
    fill: "#B7B7B9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.55554,
    y: 1.55566,
    width: 18.6667,
    height: 21.2593,
    rx: 2,
    fill: "#EDEDEE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88892,
    y: 4.66699,
    width: 11.6667,
    height: 1.25,
    rx: 0.625,
    fill: "#B7B7B9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88892,
    y: 7.77734,
    width: 7.00002,
    height: 1.25,
    rx: 0.625,
    fill: "#B7B7B9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6667,
    y: 7.77734,
    width: 3.11112,
    height: 1.25,
    rx: 0.625,
    fill: "#B7B7B9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88892,
    y: 10.8887,
    width: 9.33336,
    height: 1.25,
    rx: 0.625,
    fill: "#B7B7B9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88892,
    y: 14,
    width: 2.33334,
    height: 1.25,
    rx: 0.625,
    fill: "#B7B7B9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 3.8889,
    height: 1.25,
    rx: 0.625,
    fill: "#B7B7B9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88892,
    y: 17.1113,
    width: 7.7778,
    height: 1.25,
    rx: 0.625,
    fill: "#B7B7B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4294 21.5983C25.5885 22.4392 24.2053 22.3703 23.4522 21.4498L17.7909 14.5305L19.3616 12.9599L26.2809 18.6211C27.2013 19.3742 27.2703 20.7574 26.4294 21.5983Z",
    fill: "#EF7C00"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6339,
    y: 17.2012,
    width: 4.44241,
    height: 6.21938,
    rx: 1,
    transform: "rotate(-135 17.6339 17.2012)",
    fill: "#FF9D5A"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0056,
    y: 19.0859,
    width: 6.21938,
    height: 2.66545,
    rx: 1,
    transform: "rotate(-135 17.0056 19.0859)",
    fill: "#A7163E"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0317,
    y: 14.0596,
    width: 6.21938,
    height: 2.66545,
    rx: 1,
    transform: "rotate(-135 22.0317 14.0596)",
    fill: "#A7163E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4438 20.8242C11.8916 20.8242 11.4438 21.2719 11.4438 21.8242V22.3119C10.6624 22.6282 10.1112 23.3944 10.1112 24.2892C10.1112 24.5836 10.3499 24.8223 10.6443 24.8223H18.9072C19.2016 24.8223 19.4403 24.5836 19.4403 24.2892C19.4403 23.3943 18.889 22.6281 18.1075 22.3118V21.8242C18.1075 21.2719 17.6597 20.8242 17.1075 20.8242H12.4438Z",
    fill: "#413D45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegalDocument);
export default __webpack_public_path__ + "static/media/icon_legal_document.dfc5321694b211e37255db862e3aeb40.svg";
export { ForwardRef as ReactComponent };